import { NgModule } from '@angular/core';
import { CART_BASE_FEATURE } from '@spartacus/cart/base/root';
import { CmsConfig, provideConfig, provideConfigFactory } from '@spartacus/core';
import { defaultCheckoutConfig } from './configs/default-checkout-config';
import { defaultCheckoutRoutingConfig } from './configs/default-checkout-routing-config';
import { CHECKOUT_CORE_FEATURE, CHECKOUT_FEATURE, CheckoutEventModule } from '@spartacus/checkout/base/root';
import { interceptors } from './http-interceptors';
import { checkoutAuxOccConfig } from '../../b2b/core/checkout-aux.occ';

export const CHECKOUT_BASE_CMS_COMPONENTS: string[] = [
  'CheckoutOrchestrator',
  'CheckoutOrderSummary',
  'CheckoutProgress',
  'CheckoutProgressMobileBottom',
  'CheckoutProgressMobileTop',
  'CheckoutDeliveryMode',
  'CheckoutPaymentDetails',
  'CheckoutPlaceOrder',
  'CheckoutReviewOrder',
  'CheckoutReviewPayment',
  'CheckoutReviewShipping',
  'CheckoutReviewOverview',
  'CheckoutDeliveryAddress',
  'GuestCheckoutLoginComponent',
];

export function defaultCheckoutComponentsConfig() {
  const config: CmsConfig = {
    featureModules: {
      [CHECKOUT_FEATURE]: {
        cmsComponents: CHECKOUT_BASE_CMS_COMPONENTS,
        dependencies: [CART_BASE_FEATURE],
      },
      // by default core is bundled together with components
      [CHECKOUT_CORE_FEATURE]: CHECKOUT_FEATURE,
    },
  };
  return config;
}

@NgModule({
  imports: [CheckoutEventModule],
  providers: [
    ...interceptors,
    provideConfig(defaultCheckoutRoutingConfig),
    provideConfig(defaultCheckoutConfig),
    provideConfig(checkoutAuxOccConfig),
    provideConfigFactory(defaultCheckoutComponentsConfig),
  ],
})
export class CheckoutRootModule {}
